
<ion-header>
  <app-header pageName="Payment">
    <ion-buttons end>
      <ion-button slot="icon-only" fill="clear" (click)="onClose()" class="ion-padding-left">
        <ion-icon aria-hidden="true" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </app-header>
</ion-header>

<div class="buttons-wrapper ion-padding">
  <ion-button color="eprintprimary" fill="outline"  (click)="pay()">
    <ion-icon aria-hidden="true" slot="start" name="card-outline"></ion-icon>
    {{ 'PAY_WITH_NAYAX' | translate }}
  </ion-button>
</div>